import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {ClientUserState} from '../ClientUserState'
import {clientI18n} from '../ClientI18n'
import {tabCommunication} from '../EntryShared'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {TabCommunicationEvent} from '../tab_communication/TabCommunication'
import {UIPopupController} from '../ui_popup/UIPopupController'
import {ViewPopupInput} from '../ui_popup/ViewPopupInput'
import {UIProfileSettingsRegionChangeController} from './UIProfileSettingsRegionChangeController'
import {StorageWrapper} from '../StorageWrapper'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {ViewPopupDiscordSettings} from '../ui_popup/ViewPopupDiscordSettings'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'

export class UIProfileSettingsController {
    private readonly deleteAccountButton: HTMLDivElement

    constructor() {
        this.deleteAccountButton = document.getElementById('page-profile-settings-delete-account') as HTMLDivElement
        this.deleteAccountButton.onclick = () => {
            if(UIUtilsEjsVariables.isUserOnDiscord) {
                new ViewPopupDiscordSettings()
                return
            }
            UIProfileSettingsController.showDeleteAccountPopup()
        }

        new UIProfileSettingsRegionChangeController()
    }

    private static async checkIfUsernameMatchesInput(username: string, inputtedUsername: string) {
        if(username.toLowerCase() != inputtedUsername.toLocaleLowerCase()) {
            UIPopupController.createSimplePopup({key: 'strings:popups.errors.general.title'}, {key: 'strings:profilePage.deleteAccount.usernamesDontMatch'})
            return
        }

        const data: AjaxDataTypes.DeleteUserData = {username: inputtedUsername}
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiDeleteProfile(), undefined, data, 'application/json')
        if(response == undefined) return

        StorageWrapper.clearUserState()

        tabCommunication.sendEvent(TabCommunicationEvent.ReloadWebsite)
        navigateToPage('/?account-deleted=1')
    }

    private static showDeleteAccountPopup() {
        if(ClientUserState.userState == undefined) return
        const username = ClientUserState.userState.username
        const popup = new ViewPopupInput({key: 'strings:profilePage.deleteAccount.title'},
            {key: 'strings:profilePage.deleteAccount.body', options: {username: username}},
            (inputtedUsername) => UIProfileSettingsController.checkIfUsernameMatchesInput(username, inputtedUsername),
            () => undefined,
            true)
        popup.body.style.flexDirection = 'column'
        popup.setPlaceholder(clientI18n.t('strings:profilePage.deleteAccount.inputPlaceholder'))
        popup.setLengthLimits(1, 100)
        popup.removeXButton()
        popup.checkButton.innerText = clientI18n.t('strings:profilePage.deleteAccount.button')
        popup.checkButton.classList.add('btn_danger')
        popup.checkButton.classList.remove('btn_general_check')
        popup.checkButton.style.width = 'initial'

        popup.show()
    }
}
